import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
@Injectable({
    providedIn: "root"
})

export class ApiUrlList {


    constructor(){}
    apiUrlList: any[] = [
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/refresh_token/', id: 'refreshToken'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/login/', id: 'login'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/registration/', id: 'register'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/validate/', id: 'validateUserInputs'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/send_otp/', id: 'sendOTP'},
        // Consumer login/signup entry point: sends the OTP whether or not the
        // number has an account, and returns is_registered so the caller knows
        // which branch it is on without having to provoke a 412 to find out.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/auth_send_otp/', id: 'authSendOtp'},
        // The home-page lead form's OTP: same as authSendOtp, but its own rate limit.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/lead_send_otp/', id: 'leadSendOtp'},
        // Checks a sendOTP code without consuming it, so the signup half of the
        // login modal can reject a wrong code at the OTP step and still spend
        // the same code on `register` once name/email are in.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/signup_verify_otp/', id: 'signupVerifyOtp'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/login_send_otp/', id: 'keyclock_sendotp'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/login_verify_otp/', id: 'keyclock_verifyotp'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/reset_password/', id: 'resetPassword'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'account/update_email/', id: 'updateEmailId'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'account/profile/', id: 'profile'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/send_enquiry/', id: 'contactUs'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'account/notifications/', id: 'notifications'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'account/change_password/', id: 'changePassword'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/calculate_price_range/', id: 'dealPrice'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/user_interest/', id: 'userIntrest'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/dropdown/', id: 'dropdown'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/get_user_vehicle_list/', id: 'userVehicleList'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/insert_vehicle_address/', id: 'addAddress'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/add_bank_details/', id: 'addBankDetails'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/check_dealer/', id: 'checkDealer'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/nearby_centers/', id: 'nearbyCenters'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'deal/create_t_urn/', id: 'create_opportunity'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/search_district/', id: 'search_district'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'account/logout/', id: 'logout'},
        // Home-page "Get the best price for your Vehicle" widget (anonymous).
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_vehicle_lookup/', id: 'quoteVehicleLookup'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_model_search/', id: 'quoteModelSearch'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_send_otp/', id: 'quoteSendOtp'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_verify_otp/', id: 'quoteVerifyOtp'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_estimate/', id: 'quoteEstimate'},
        // Read-only "can this vehicle be priced at this pincode?", asked before
        // the OTP so an unpriceable vehicle is caught on the form instead of
        // after the customer has verified a number and had a URN minted.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_price_check/', id: 'quotePriceCheck'},
        // Keeps an enquiry the widget cannot serve (uncovered area, unpriceable
        // vehicle) as a T-URN before the OTP, as the old wizard's create_t_urn did.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/quote_t_urn/', id: 'quoteTUrn'},
        // Public website CMS content (TML Admin edits it from the Flutter app).
        // Read only through CmsService, which falls back to the bundled copy
        // when these are down or empty.
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/home/', id: 'cmsHome'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/faq/', id: 'cmsFaq'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/media/', id: 'cmsMedia'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/blog/', id: 'cmsBlog'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/parts_banner/', id: 'cmsPartsBanner'},
        {apiUrl: environment.httpPort + environment.apiVersion + 'no_auth/cms/about_us/', id: 'cmsAboutUs'}



    ]

    returnAPI(id: String){
        let fetchedAPI = this.apiUrlList.find(x => x.id === id);
        return fetchedAPI.apiUrl;
    }
}
